import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiListItemText from '@material-ui/core/ListItemText';
import { combineClasses, omit, styled, useDeprecatedCheck, useThemeProps, } from '../../../foundation';
import { ListItemTextStyle } from './styles';
import { RcListItemTextClasses } from './utils';
var _RcListItemText = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcListItemText' });
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useDeprecatedCheck(RcListItemText, props, [
            {
                prop: 'primaryColor',
                time: '2021-4',
                comment: 'recommend use primaryTypographyProps color prop',
            },
            {
                prop: 'alignCenter',
                time: '2021-4',
                comment: "recommend using classes to define it",
            },
            {
                prop: 'lineThrough',
                time: '2021-4',
                comment: "recommend using classes to define it",
            },
        ]);
    }
    var classesProp = props.classes, children = props.children, isEllipsis = props.isEllipsis, primaryTypographyPropsProp = props.primaryTypographyProps, secondaryTypographyPropsProp = props.secondaryTypographyProps, primaryColor = props.primaryColor, alignCenter = props.alignCenter, lineThrough = props.lineThrough, rest = __rest(props, ["classes", "children", "isEllipsis", "primaryTypographyProps", "secondaryTypographyProps", "primaryColor", "alignCenter", "lineThrough"]);
    var classes = useMemo(function () { return combineClasses(RcListItemTextClasses, classesProp); }, [classesProp]);
    var primaryTypographyProps = useMemo(function () { return omit(primaryTypographyPropsProp, ['color', 'variant']); }, [primaryTypographyPropsProp]);
    var secondaryTypographyProps = useMemo(function () { return omit(secondaryTypographyPropsProp, ['color', 'variant']); }, [secondaryTypographyPropsProp]);
    return (React.createElement(MuiListItemText, __assign({}, rest, { ref: ref, classes: classes, primaryTypographyProps: primaryTypographyProps, secondaryTypographyProps: secondaryTypographyProps }), children));
});
var RcListItemText = styled(_RcListItemText)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), ListItemTextStyle);
RcListItemText.defaultProps = {
    isEllipsis: true,
    primaryTypographyProps: {
        variant: 'body1',
        color: 'neutral.f06',
    },
    secondaryTypographyProps: {
        variant: 'caption1',
        color: 'neutral.f04',
    },
};
RcListItemText.displayName = 'RcListItemText';
export { RcListItemText };
var templateObject_1;
